import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { font } from '@/constant/font';
export default function AvailableLabel({ availableState, text, }) {
    return (_jsx(Label, { availableState: availableState, children: _jsx(LabelText, { availableState: availableState, children: text }) }));
}
const Label = styled.View `
  border-radius: 8px;
  background-color: ${({ availableState }) => availableState === 'AVAILABLE'
    ? '#D9FFE6'
    : availableState === 'UNAVAILABLE'
        ? '#FEECEC'
        : '#EFF0F2'};
  padding: 4px 8px 4px 8px;
`;
const LabelText = styled.Text `
  font-size: 12px;
  font-family: ${() => font.pretendardMedium};
  color: ${({ availableState }) => availableState === 'AVAILABLE'
    ? '#009632'
    : availableState === 'UNAVAILABLE'
        ? '#E52222'
        : '#24262B'};
`;
